import { gql, useMutation } from "@apollo/client";

import {
    ClientUserInviteMutation,
    ClientUserInviteMutationVariables,
    GqlClientUser,
    GqlClientUserInviteInput,
} from "~/__generated__";

const CLIENT_USER_INVITE = gql(`
    mutation ClientUserInvite($input: GqlClientUserInviteInput!) {
        clientUserInvite(input: $input) {
            id
        }
    }
`);

export default function useClientUserInvite() {
    const [mutate, { loading, error, data }] = useMutation<ClientUserInviteMutation, ClientUserInviteMutationVariables>(
        CLIENT_USER_INVITE,
        {
            errorPolicy: "all",
        },
    );

    const inviteClientUser = (input: GqlClientUserInviteInput) => mutate({ variables: { input } });

    return {
        inviteClientUser,
        loading,
        error,
        data: data?.clientUserInvite as GqlClientUser | undefined,
    };
}
